import { MarketplaceRetailerLink } from '../../types/marketplace-retailer-link'
import { FeaturedLink } from '../../types/featured-link'

export function marketplaceRetailerLinkToFeaturedLink(
  retailer: MarketplaceRetailerLink
): FeaturedLink {
  const { logoUrl, ...rest } = retailer
  return rest
}
